module.exports = __webpack_public_path__ + "img/EMT-PRCA_10X_AIC.3ac7f0de.png";